export default "__VITE_ASSET__BJ61v2O3__"